import React from 'react'


const ReportRemoverConfirm=()=>{
	return(
		<div className="modal fade" id="delete-request-modal" >
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<h4 className="modal-title">Your report will be deleted</h4>
						<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
					</div>
					<div className="modal-body" id="delete-report-text">
						Your deletion request has been recorded and will be deleted within 6 months as per our data handling terms (https://www.meterian.com/gdpr.html).  <br />
						If you need this to be deleted sooner, please email <a href="mailto:support@meterian.com">support@meterian.com</a>
					</div>
					<div className="modal-footer">
						<button type="button" data-dismiss="modal" className="btn">Close</button>
					</div>
				</div>
			</div>
		</div>
	)
}


export default ReportRemoverConfirm